const isPromise = (obj) => {
  return obj && typeof obj.then === "function";
};
export {
  isPromise
};
//# sourceMappingURL=isPromise.js.map
